module.exports = __webpack_public_path__ + "static/media/FPWandFPSerialModelNumbers.4384c509.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/FPWandFPSerialModelNumbers.jpg
// module id = 1275
// module chunks = 0